<!--
  navItem „Haftung“ — Haftungstyp, Haftungszeitraum und Haftungsbeträge.
  Haftungsart, Zuordnung und Herkunft rechnet der Lauf; sie tragen bis dahin pro Feld
  „nicht berechnet“. Zeitraum, Status und Beträge sind NOT NULL und stehen immer.
-->
<div class="cp-provision-contract-agent-liability">

    <cp-provision-object-data
            objectType="cp.ProvisionContractAgent"
            [objectId]="provisionContractAgentId"
            widgetAlias="cp.contractAgent.liability"
            widgetTitle="Haftung"
            [fields]="fields"
            [pendingFields]="pendingFields"
            [columns]="columns"
            emptyText="Kein Provisionssatz ausgewählt.">
    </cp-provision-object-data>

</div>
